import StpTooltipSettings from "./components/StpTooltipSettings";

const Plugin = {
  install(app) {
    app.component("stp-tooltip-settings", StpTooltipSettings);
  },
};

export default Plugin;
